import { metrics } from '@atlassian/browser-metrics';

/**
 * @deprecated use 'aiAnswerDialogMetric' from common instead
 */
export const aiAnswerDialogMetric: import('@atlassian/browser-metrics/types').PageSegmentLoadMetric =
	metrics.pageSegmentLoad({
		key: 'ai-search-dialog',
	});
